import { combineReducers } from 'redux';
import teams from './teams.js';
import trials from './trials.js';
import stages from './stages.js';
import participants from './participants.js';
import responses from './responses.js';

const reducers = combineReducers({ teams, trials, stages, participants, responses });

export default reducers;
